<template>
  <main class="UseCase">
    <section class="UseCase__info">
      <div class="UseCase__info-main">
        <div class="UseCase__info-title">
          {{ activeCase.title }}
        </div>
        <div class="UseCase__info-subtitle" v-html="activeCase.subtitle"></div>
      </div>
      <div class="UseCase__info--image">
        <video :key="activeCase.title" v-if="activeCase.video" autoplay muted loop controls>
          <source :src="activeCase.video" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <img v-else :src="activeCase.image">
      </div>
      <div class="UseCase__info-cases">
        {{ usecases.items }}
        <card v-for="(item, name) in activeCase.items" :key="name" :title="getCardTitle(name)" :content="item"></card>
      </div>
      <div class="UseCase__info-capsule">
        <img class="UseCase__info-capsule--img" :src="activeCase.capsule"/>
        <img class="UseCase__info-capsule--figure" src="/img/background-shapes/elipse-blue.svg"/>
      </div>
    </section>
    <section class="UseCase__capsules">
      <h2 class="UseCase__others-title">
        {{ activeCase.title }} Capsules
      </h2>
      <slider>
        <template v-slot:content>
          <capsule
            v-for="(item, index) in activeCase.capsules"
            :key="index"
            :image="item.image"
            :name="item.name"
            :volume="item.volume"
          />
        </template>
      </slider>
    </section>
    <section class="UseCase__others">
      <h2 class="UseCase__others-title">
        Other Use Cases
      </h2>
      <slider>
        <template v-slot:content>
          <use-case-card
              v-for="(item, index) in otherCases"
              :key="index"
              :image="item.image"
              :title="item.title"
              :description="item.description"
              :url="item.path"
          />
        </template>
      </slider>
    </section>
  </main>
</template>
<script>
import { USECASES } from "../assets/useCases";
import UseCaseCard from "../components/items/UseCaseCard";
import Card from "../components/common/Card";
import Slider from "../components/items/Slider";
import Capsule from "../components/items/Capsule";

export default {
  name: 'UseCase',
  components: {
    'slider': Slider,
    'use-case-card': UseCaseCard,
    'card': Card,
    'capsule': Capsule
  },
  data: () => ({
    usecases: USECASES
  }),
  computed: {
    activeCase() {
      return this.usecases.find(item => item.value === this.$route.params.usecase)
    },
    otherCases() {
      return this.usecases.filter(item => item.value !== this.activeCase.value)
    }
  },
  methods: {
    getCardTitle(key) {
      if (key === 'personalization') return 'Personalization'
      else if (key === 'activeIngredients') return 'Active Ingredients'
      else if (key === 'naturalClean') return 'Natural & Clean'
      else if (key === 'foodIngredients') return 'Food Ingredients'
    },
  }
}
</script>
<style lang="scss">
.UseCase {
  margin: 90px 30px;
  @include content;
  &__info {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: auto auto;
    grid-column-gap: 60px;
    grid-row-gap: 50px;
    justify-content: center;
    color: $color;
    margin: 0 32px 100px;
    &--image{
      img, video {
        border-radius: 24px;
        width: 100%;
        max-width: 565px;
      }
    }
    &-capsule {
      position: relative;
      height: 100%;
      &--img {
        max-width: 490px;
        width: 100%;
        transform: rotate(-23deg);
        @media screen and (max-width: 775px) {
          width: 90%;
        }
      }
      &--figure {
        max-width: 565px;
        width: 88%;
        position: absolute;
        top: 50px;
        left: 40px;
        z-index: -1;
        @media screen and (max-width: 1100px) {
          top: 60px;
        }
      }
      @media screen and (max-width: 775px) {
        text-align: center;
        &--figure {
          max-width: 440px;
          width: 90%;
          left: 53%;
          transform: translateX(-50%);
        }
      }
    }
    &-title {
      margin-bottom: 30px;
      font-weight: bold;
      font-size: 64px;
      line-height: 110%;
      @media screen and (max-width: 775px) {
        font-size: 42px;
        margin-top: 20px;
      }
    }
    &-subtitle {
      font-size: 20px;
      font-weight: 600;
      line-height: 150%;
      @media screen and (max-width: 775px) {
        font-size: 18px;
        margin-bottom: 25px;
      }
    }
    &-main {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
    }
    &-text {
      p {
        font-size: 20px;
        line-height: 150%;
        margin-bottom: 15px
      }
    }
    @media screen and (max-width: 775px){
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto auto;
      grid-column-gap: 0;
      grid-row-gap: 0;
      padding: 0 3%;
      margin: 30px 0 100px;
    }
  }
  &__capsules {
    margin-bottom: 50px;
  }
  &__others {
    color: $color;
    &-title {
      font-weight: bold;
      font-size: 64px;
      line-height: 110%;
      @media screen and (max-width: 775px) {
        font-size: 42px;
      }
    }
    @media screen and (max-width: 775px) {
      margin-top: 80px;
      padding-left: 3%;
    }
  }
}
</style>
